import { current } from "@reduxjs/toolkit";
import { isAdmin } from "src/Common/function";
import api from "./api";
import UserService from "./user.service";

//This function is for admin
// `filters` (optional): { customerIds, branchIds, locationIds, technicianIds }.
// Empty arrays mean "all" for that dimension; the backend treats them as no-ops.
const sendWOReport = (
  recipients,
  all,
  past7Days,
  past30Days,
  customDays,
  customStartDate,
  customEndDate,
  date,
  type,
  filters = {}
) => {
  return api.post("/api/wo/send_wo_report", {
    recipients,
    all,
    past7Days,
    past30Days,
    customDays,
    customStartDate,
    customEndDate,
    date,
    type,
    ...filters,
  });
};

const sendHoursWorkedReport = (
  branchId,
  recipients,
  past7Days,
  past30Days,
  customDays,
  customStartDate,
  customEndDate,
  date,
  filters = {}
) => {
  return api.post("/api/report/send_hours_worked_report", {
    branchId,
    recipients,
    past7Days,
    past30Days,
    customDays,
    customStartDate,
    customEndDate,
    date,
    ...filters,
  });
};

// The preview endpoints return one page of rows at a time. `page` is 0-based;
// the response carries `recordsFound` (the full match count, not just this
// page), `rows`, `page`, and `pageSize`.
const getWOReportPreview = (
  all,
  past7Days,
  past30Days,
  customDays,
  customStartDate,
  customEndDate,
  date,
  type,
  filters = {},
  page = 0
) => {
  return api.post("/api/wo/wo_report_preview", {
    all,
    past7Days,
    past30Days,
    customDays,
    customStartDate,
    customEndDate,
    date,
    type,
    ...filters,
    page,
  });
};

const getHoursWorkedReportPreview = (
  branchId,
  past7Days,
  past30Days,
  customDays,
  customStartDate,
  customEndDate,
  date,
  filters = {},
  page = 0
) => {
  return api.post("/api/report/hours_worked_report_preview", {
    branchId,
    past7Days,
    past30Days,
    customDays,
    customStartDate,
    customEndDate,
    date,
    ...filters,
    page,
  });
};

// `args`: { past7Days, past30Days, customDays, customStartDate, customEndDate,
// woNumber, page, filters: { customerIds, branchIds, locationIds, technicianIds } }.
// Empty filter arrays mean "all"; an empty woNumber means "all work orders".
// `page` is 0-based and selects which page of rows the preview returns.
const getRefrigerantReportPreview = (args) => {
  const { filters = {}, ...rest } = args;
  return api.post("/api/report/refrigerant_report_preview", { ...rest, ...filters });
};

const sendRefrigerantReport = (args) => {
  const { filters = {}, ...rest } = args;
  return api.post("/api/report/send_refrigerant_report", { ...rest, ...filters });
};

// `args`: { past7Days, past30Days, customDays, customStartDate, customEndDate,
// date, woNumber, page, filters: { customerIds, branchIds, locationIds, technicianIds } }.
// Empty filter arrays mean "all"; an empty woNumber means "all work orders".
// `page` is 0-based and selects which page of rows the preview returns.
const getRecommendationReportPreview = (args) => {
  const { filters = {}, ...rest } = args;
  return api.post("/api/report/recommendation_report_preview", { ...rest, ...filters });
};

const sendRecommendationReport = (args) => {
  const { filters = {}, ...rest } = args;
  return api.post("/api/report/send_recommendation_report", { ...rest, ...filters });
};

const create = (data) => {
  return api.post("/api/report/create", data);
};

const getAll = (branch) => {
  // let currentUser = UserService.getCurrentUser();
  // let branchId = branch;
  // if (!isAdmin()) {
  //   branchId = currentUser.branches[0].id;
  // }
  return api.get("/api/report/get_all", { params: { branchId: branch } });
};

const deleteReport = (id) => {
  return api.get("/api/report/delete", { params: { id } });
};

const update = (id, data) => {
  return api.post("/api/report/update", { id, data });
};

const ReportService = {
  sendWOReport,
  sendHoursWorkedReport,
  getWOReportPreview,
  getHoursWorkedReportPreview,
  getRefrigerantReportPreview,
  sendRefrigerantReport,
  getRecommendationReportPreview,
  sendRecommendationReport,
  create,
  getAll,
  deleteReport,
  update,
};

export default ReportService;
